/* eslint-disable global-require */
const images = {
  alertIcon: require('./images/icons/small/ic-alert.svg').default,
  alertIconLarge: require('./images/icons/small/ic-alert@2x.png'),
  assignIcon: require('./images/icons/small/assign.svg').default,
  bellIcon: require('./images/icons/small/ic-bell.svg').default,
  calendarViewIcon: require('./images/icons/small/calendar-month-icon.svg').default,
  checkIcon: require('./images/icons/small/ic-check.svg').default,
  chevronGreenIcon: require('./images/icons/small/ic-chevron-down-green.svg').default,
  chevronGreyIcon: require('./images/icons/small/ic-chevron-down-grey.svg').default,
  chevronIcon: require('./images/icons/small/ic-chevron-down.svg').default,
  chevronOrangeIcon: require('./images/icons/small/ic-chevron-down-orange.svg').default,
  chevronPurpleIcon: require('./images/icons/small/ic-chevron-down-purple.svg').default,
  chevronRedIcon: require('./images/icons/small/ic-chevron-down-red.svg').default,
  chevronYellowIcon: require('./images/icons/small/ic-chevron-down-yellow.svg').default,
  closeIcon: require('./images/icons/small/ic-close.svg').default,
  closeIconGreen: require('./images/icons/small/ic-close-green.svg').default,
  dCentrIQPowerCentral: require('./images/02-images-img-logo-decentriq.svg').default,
  deleteDarkIcon: require('./images/icons/small/ic-delete-dark.svg').default,
  deleteIcon: require('./images/icons/small/ic-delete.svg').default,
  documentManager: require('./images/icons/resources/01-icons-02-categories-ic-ician.svg').default,
  downloadExcel: require('./images/01-icons-01-small-ic-excel.png'),
  duplicateIcon: require('./images/icons/small/ic-duplicate.svg').default,
  editDarkIcon: require('./images/icons/small/ic-edit-dark.svg').default,
  editGreenIcon: require('./images/icons/small/ic-edit-green.svg').default,
  elipsisIcon: require('./images/icons/small/elipsis.svg').default,
  emulatedSites: require('./images/icons/small/emulated.svg').default,
  emptyEnvelop: require('./images/icons/appBar/ic-notification.svg').default,
  eyeVisibility: require('./images/icons/small/eye-visibility.svg').default,
  eyeVisibilityOff: require('./images/icons/small/eye-visibilityoff.svg').default,
  iconAlarm: require('./images/icons/status/ic-alarm.svg').default,
  iconAll: require('./images/icons/categories/ic-all.svg').default,
  iconAts: require('./images/icons/categories/ic-ats.svg').default,
  iconBattery: require('./images/icons/categories/ic-battery.svg').default,
  iconBellWhite: require('./images/icons/appBar/ic-bell.svg').default,
  iconCarBattery: require('./images/icons/categories/ic-car-battery.svg').default,
  iconCellular: require('./images/icons/connection/ic-cellular.svg').default,
  iconCellularWhite: require('./images/icons/connection/ic-cellular-white.svg').default,
  iconCheck: require('./images/icons/status/ic-check.svg').default,
  iconComissioning: require('./images/icons/status/ic-comissioning.png'),
  iconConfiguration: require('./images/icons/large/ic-config.svg').default,
  iconCustomerDocumentation:
    require('./images/icons/resources/01-icons-02-categories-ic-customer.svg').default,
  iconDashboard: require('./images/icons/menu/Dashboard.svg').default,
  iconDdr: require('./images/icons/categories/ic-ddr.svg').default,
  iconEmulator: require('./images/icons/status/ic-emulator.svg').default,
  iconEss: require('./images/icons/categories/ic-ess.svg').default,
  iconEv: require('./images/icons/categories/ic-ev.svg').default,
  iconFaulted: require('./images/icons/status/ic-faulted.svg').default,
  iconFleet: require('./images/icons/categories/ic-fleet.svg').default,
  iconFuel: require('./images/icons/categories/ic-fuel.svg').default,
  iconGid: require('./images/icons/categories/ic-gid.svg').default,
  iconIcianDocumentation: require('./images/icons/resources/01-icons-02-categories-ic-ician.svg')
    .default,
  iconInfo: require('./images/icons/small/ic-info.svg').default,
  iconInverter: require('./images/icons/categories/ic-inverter.svg').default,
  iconIsland: require('./images/icons/connection/ic-island.svg').default,
  iconLocalIO: require('./images/icons/categories/ic-localio.svg').default,
  iconLogout: require('./images/icons/appBar/ic-logout.svg').default,
  iconMaintenance: require('./images/icons/status/ic-maintenance.svg').default,
  iconMeters: require('./images/icons/categories/ic-meters.svg').default,
  iconOk: require('./images/btn-checked.svg').default,
  iconOverviewAndBackground:
    require('./images/icons/resources/01-icons-02-categories-ic-overview.svg').default,
  iconResources: require('./images/icons/menu/Resources.svg').default,
  iconSettings: require('./images/icons/menu/menu-configuration.svg').default,
  iconSites: require('./images/icons/menu/menu-sites.svg').default,
  iconSolar: require('./images/icons/categories/ic-solar.svg').default,
  iconSupportTeamDocumentation:
    require('./images/icons/resources/01-icons-02-categories-ic-support.svg').default,
  iconTower: require('./images/icons/connection/ic-tower.svg').default,
  iconUnknown: require('./images/icons/connection/ic-unknown.svg').default,
  iconUnknownWhite: require('./images/icons/connection/ic-unknown-white.svg').default,
  iconUtility: require('./images/icons/categories/ic-utility.svg').default,
  iconWarning: require('./images/icons/status/ic-warning.svg').default,
  iconWifiConnected: require('./images/icons/connection/ic-wifi-connected.svg').default,
  iconWifiConnectedWhite: require('./images/icons/connection/ic-wifi-connected-white.svg').default,
  iconWifiDisconnected: require('./images/icons/connection/ic-wifi-disconnected.svg').default,
  iconWifiDisconnectedWhite: require('./images/icons/connection/ic-wifi-disconnected-white.svg')
    .default,
  iconWind: require('./images/icons/categories/ic-wind.svg').default,
  listViewIcon: require('./images/icons/small/list-view-icon.svg').default,
  loginBackImage: require('./images/entech-lifestyle-square.png'),
  loginBrandingImage: require('./images/logo-branding-lg.jpg').default,
  logoBrandingSM: require('./images/logo-eec-white-sm@3x.png'),
  logoWhiteSM: require('./images/logo-white-sm.svg').default,
  maintenanceBroadcastIcon: require('./images/icons/small/ic-maintenance.svg').default,
  map: require('./images/icons/large/ic-map.svg').default,
  mapExpand: require('./images/icons/small/ic-map-expand.svg').default,
  mapLocate: require('./images/icons/small/ic-map-locate.svg').default,
  microsoftIcon: require('./images/ic-logowindows.png'),
  noEmulatedSites: require('./images/icons/small/no-emulated.svg').default,
  notificationRowBellIcon: require('./images/icons/small/group.svg').default,
  notifications: require('./images/icons/resources/01-icons-02-categories-ic-customer.svg').default,
  pin: require('./images/pin.svg').default,
  pinAlarm: require('./images/icons/status/ic-pin-alarm.svg').default,
  pinFaulted: require('./images/icons/status/ic-pin-faulted.svg').default,
  pinMaintenance: require('./images/icons/status/ic-pin-maintenance.svg').default,
  pinOk: require('./images/icons/status/ic-pin-ok.svg').default,
  pinWarning: require('./images/icons/status/ic-pin-warning.svg').default,
  pinWhite: require('./images/icons/status/ic-pin-white.svg').default,
  powerBI: require('./images/icons/menu/PowerBI.svg').default,
  redBellIcon: require('./images/icons/small/ic-bell-red.svg').default,
  reportEmail: require('./images/01-icons-01-small-ic-share.png'),
  reportPdf: require('./images/01-icons-01-small-ic-pdf.svg').default,
  reportPrint: require('./images/01-icons-01-small-ic-print.png'),
  reports: require('./images/icons/menu/menu-reports.svg').default,
  searchIcon: require('./images/icons/small/ic-search.svg').default,
  userRoleConfig: require('./images/icons/resources/user-role-svgrepo-com.svg').default,
  userRoleConfigIcon: require('./images/icons/resources/user-role-svgrepo-com.svg').default,
  viewList: require('./images/icons/small/ic-view-list.svg').default,
  viewMap: require('./images/icons/small/ic-view-map.svg').default,
  xCapePowerCentral: require('./images/02-images-img-logo-xcape.svg').default,
};

export default images;
